/**
 * Created by pmnia on 28/11/14.
 */
(function(){
    "use strict";
    angular
        .module('blocks.storage')
        .factory('obtStorage', obtStorage);

    /*@ngInject*/
    function obtStorage($sessionStorage, $state, config, _, logger){
        return ({
            findSession: findSession,
            removeSession: removeSession,
            addSession: addSession
        });

        function addSession(session) {
            if (!$sessionStorage.obtSessions) {
                $sessionStorage.obtSessions = [];
            }
            $sessionStorage.obtSessions.push(session);
        }

        function findSessionBycId(cId, removeSelected) {
            if (angular.isUndefined(cId)) {
                return null;
            }
            if (angular.isUndefined(removeSelected)) {
                removeSelected = false;
            }

            /*return -1 if not found*/
            var uiToUse = $state.current && $state.current.obtVid && $state.current.obtPage ?
                          $state.current.obtVid +''+ $state.current.obtPage : config.ui;
            var itemIndex = _.findIndex($sessionStorage.obtSessions, function(session) {
                return session.cId === cId && session.ui === uiToUse;
            });

            if (itemIndex >= 0) {
                return removeSelected ? $sessionStorage.obtSessions.splice(itemIndex, 1)
                                    : $sessionStorage.obtSessions[itemIndex];
            }
            return null;
        }

        function findSession(cId){
            return findSessionBycId(cId, false);
        }

        function removeSession(cId){
            while (findSessionBycId(cId, true)){
                logger.log('session' + cId + ': removed');
            }
        }
    }
})();




/*****************
 ** WEBPACK FOOTER
 ** ./app/blocks/storage/storage.service.js
 ** module id = 98
 ** module chunks = 0
 **/